<script>
import { ChevronDownIcon, EarthIcon } from '@thehotelsnetwork/icons/vue/linear';

import HelpBtn from '@/components/HelpBtn/HelpBtn.vue';
import ThnProductNav from '@/components/ThnProductNav/ThnProductNav.vue';
import LangSelect from '@/components/LangSelect/LangSelect.vue';

export default {
  components: {
    ChevronDownIcon,
    EarthIcon,
    HelpBtn,
    ThnProductNav,
    LangSelect,
  },
};
</script>

<template>
  <header
    class="z-30 flex items-center justify-between w-full h-16 p-4 sn-header-width"
  >
    <div class="flex items-center">
      <thn-product-nav />
    </div>

    <div class="flex">
      <help-btn class="mr-6" />
      <LangSelect
        x-position="right"
        class="z-60"
      >
        <template #trigger="{ label, open }">
          <div
            :class="[
              'px-4 py-2 bg-white flex items-center space-x-3 cursor-pointer rounded border border-transparent',
              'transition hover:border-base-900',
              { 'border-base-900': open },
            ]"
          >
            <EarthIcon class="w-5 h-5" />
            <span class="flex-1 block min-w-lang-label">{{ label }}</span>
            <ChevronDownIcon class="w-3 h-3" />
          </div>
        </template>
      </LangSelect>
    </div>
  </header>
</template>
